<template>
<div>
    <h1 class="subtitle">Caja Chica: {{ caja.caj_codigo }}</h1>
    <div class="nj-cols">
        <div class="nj-card">
            <div>
                <div class="nj-subtitle-1">Datos principales</div>
                <div class="nj-cols form c2">
                    <div>
                        <LabelGroup label="Titulo" :value="caja.caj_titulo"></LabelGroup>
                        <LabelGroup label="Descripcion" :value="caja.caj_descripcion"></LabelGroup>
                    </div>
                    <div>
                        <div class="nj-cols form c3">
                            <LabelGroup label="Centro costo" :value="caja.cec_descripcion"></LabelGroup>
                            <LabelGroup label="Estado" :value="caja.est_descripcion"></LabelGroup>
                        </div>
                        <div class="nj-cols form c3">
                            <LabelGroup label="Tipo caja" :value="caja.tca_descripcion"></LabelGroup>
                            <LabelGroup label="Monto" :value="caja.caj_monto_text"></LabelGroup>
                            <LabelGroup label="Fecha registro" :value="caja.caj_fecha_registro"></LabelGroup>
                            <LabelGroup label="Solicitante" :value="caja.usu_nombre_solicitante"></LabelGroup>
                            <LabelGroup label="Gerente" :value="caja.usu_nombre_gerente | empty"></LabelGroup>
                            <LabelGroup label="Registrado por" :value="caja.usu_nombre_creador"></LabelGroup>
                        </div>
                    </div>
                </div>
                <Buttons line v-if="mostrarBotonesPrincipales">
                    <button class="nj-button" style="font-size: 14px;" v-if="caja.caj_opciones && caja.caj_opciones.aprobar_caja" @click="aprobarCaja()"><i class="mdi mdi-arrow-right-box"></i>Aprobar
                        Caja</button>
                    <button class="nj-button" style="font-size: 14px;" v-if="caja.caj_opciones && caja.caj_opciones.desaprobar_caja" @click="desaprobarCaja()"><i
                            class="mdi mdi-arrow-right-box"></i>Desaprobar Caja</button>
                    <button class="nj-button" style="font-size: 14px;" v-if="caja.caj_opciones && caja.caj_opciones.aprobar_rendicion" @click="aprobarRendicion()"><i
                            class="mdi mdi-arrow-right-box"></i>Aprobar Rendición</button>
                    <button class="nj-button" style="font-size: 14px;" v-if="caja.caj_opciones && caja.caj_opciones.desaprobar_rendicion" @click="desaprobarRendicion()"><i
                            class="mdi mdi-arrow-right-box"></i>Desaprobar Rendición</button>
                </Buttons>
                <Buttons line>
                    <button class="nj-button c-yellow" @click="obtenerCaja"><i class="mdi mdi-reload"></i></button>
                    <button class="nj-button" v-if="caja.caj_opciones && caja.caj_opciones.editar_caja" @click="editar()"><i class="mdi mdi-pen"></i>Editar</button>
                    <button class="nj-button" v-if="caja.caj_opciones && caja.caj_opciones.solicitar_aprobacion_caja" @click="solicitarAprobacionCaja()"><i class="mdi mdi-email"></i>Solicitar
                        Aprobación Caja</button>
                    <button class="nj-button" v-if="caja.caj_opciones && caja.caj_opciones.solicitar_aprobacion_rendicion" @click="solicitarAprobacionRendicion()"><i
                            class="mdi mdi-email"></i>Solicitar Aprobación Rendición</button>
                    <button class="nj-button" v-if="caja.caj_opciones && caja.caj_opciones.depositar_caja" @click="depositar"><i class="mdi mdi-arrow-right-box"></i>Depositar Caja</button>
                    <button class="nj-button" v-if="caja.caj_opciones && caja.caj_opciones.agregar_rendicion" @click="agregarRendicion()"><i class="mdi mdi-arrow-right-box"></i>Agregar / Editar
                        Rendición</button>
                    <button class="nj-button" v-if="caja.caj_opciones && caja.caj_opciones.cancelar_caja" @click="cancelar()"><i class="mdi mdi-cancel"></i>Cancelar Caja</button>
                    <button class="nj-button" @click="cerrar()"><i class="mdi mdi-keyboard-backspace"></i>Regresar a la búsqueda</button>
                </Buttons>
            </div>
        </div>
        <div class="nj-card" v-if="rendicion">
            <div class="nj-line"></div>
            <div class="nj-cols form c2">
                <div class="nj-subtitle-1">Rendición</div>
                <div v-if="rendicion" class="nj-flx totales" style="padding: 0 12px;">
                    <div>
                        <div class="bold">Total <span class="hide">Rendición</span>:</div>
                        <div>{{ rendicion.ren_total_text }}</div>
                    </div>
                    <div class="nj-bar hide"></div>
                    <div>
                        <div class="bold">Saldo <span class="hide">Rendición</span>:</div>
                        <div>{{ rendicion.ren_saldo_text }}</div>
                    </div>
                </div>
            </div>
            <b-table :data="documentos">
                <template slot-scope="props">
                    <b-table-column label="Fecha" header-class="is-info">{{ props.row.red_fecha }}</b-table-column>
                    <b-table-column label="DNI / RUC" header-class="is-info">{{ props.row.red_dni_ruc }}</b-table-column>
                    <b-table-column label="Razon social" header-class="is-info">{{ props.row.red_razon_social }}</b-table-column>
                    <b-table-column label="Descripcion" header-class="is-info">{{ props.row.red_descripcion }}</b-table-column>
                    <b-table-column label="Centro costo" header-class="is-info">{{ props.row.cec_codigo }}</b-table-column>
                    <b-table-column label="Tipo documento" header-class="is-info">{{ props.row.tid_descripcion }}</b-table-column>
                    <b-table-column label="Serie" header-class="is-info">{{ props.row.red_serie }}</b-table-column>
                    <b-table-column label="Número" header-class="is-info">{{ props.row.red_numero }}</b-table-column>
                    <b-table-column label="Importe" header-class="is-info" style="text-align: right;">{{ props.row.red_importe_text }}</b-table-column>
                </template>
            </b-table>
            <br>
            <div class="nj-subtitle-1">Archivos Adjuntos</div>
            <a :href="url_pdf" v-if="url_pdf" class="pdf-adjunto" target="_blank">
                <i class="mdi mdi-file-pdf-box"></i>
                <span>{{ url_pdf | file_name }}</span>
            </a>
        </div>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"

import { CajaService, RendicionService, UsuarioService } from "../../services"
import Environment from "../../services/Environment"
import Toast from "../../util/toast"
import { Buttons, LabelGroup } from "../components"

export default {
    name: "VerCaja",
    components: {
        LabelGroup,
        Buttons,
    },
    data() {
        return {
            caja: {
                caj_id: this.$route.params.id
            },
            file: null,
            sequence: 1,
            serverUrl: Environment.url,
            rendicion: null,
            documentos: [],
            url_pdf: null,
        }
    },
    computed: {
        ...mapGetters("AppStore", ["url"]),
        usuario() {
            return UsuarioService.getUsuario()
        },
        mostrarBotonesPrincipales() {
            if (
                this.caja.caj_opciones && this.caja.caj_opciones.aprobar_caja ||
                this.caja.caj_opciones && this.caja.caj_opciones.desaprobar_caja ||
                this.caja.caj_opciones && this.caja.caj_opciones.aprobar_rendicion ||
                this.caja.caj_opciones && this.caja.caj_opciones.desaprobar_rendicion
            ) {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        ...mapActions("AppStore", ["_loadingOn", "_loadingOff", "_setMessage"]),
        obtenerCaja() {
            CajaService
                .obtener({
                    caja: this.caja,
                    usuario: UsuarioService.getUsuario()
                }).then(
                    response => {
                        this.caja = response.data
                        this.url_pdf = this.caja.caj_url_pdf
                        RendicionService
                            .obtenerRendicionxCaja(this.caja).then(
                                response => {
                                    this.rendicion = response.data
                                    this.documentos = this.rendicion?.lista_rendicion_detalle
                                },
                                error => {
                                    Toast.error(error)
                                    console.error(`error: `, error)
                                }
                            )
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
        },
        cerrar() {
            this.$router.push("/caja")
        },
        solicitarAprobacionCaja() {
            CajaService
                .solicitarAprobacionCaja({
                    caj_id: this.caja.caj_id
                }).then(
                    response => {
                        Toast.success(response.message)
                        this.obtener()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
        },
        solicitarAprobacionRendicion() {
            RendicionService
                .solicitarAprobacionRendicion({
                    caj_id: this.caja.caj_id
                }).then(
                    response => {
                        Toast.success(response.message)
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    },
                )
        },
        aprobarCaja() {
            CajaService
                .aprobar({
                    caj_id: this.caja.caj_id,
                    usu_aprobador: this.usuario.usu_id
                }).then(
                    response => {
                        Toast.success(response.message)
                        this.obtenerCaja()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    },
                )
        },
        desaprobarCaja() {
            CajaService
                .desaprobar({
                    caj_id: this.caja.caj_id
                }).then(
                    response => {
                        Toast.success(response.message)
                        this.obtenerCaja()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    },
                )
        },
        aprobarRendicion() {
            RendicionService
                .aprobar({
                    caj_id: this.caja.caj_id,
                    usu_aprobador_rendicion: this.usuario.usu_id
                }).then(
                    response => {
                        Toast.success(response.message)
                        this.obtenerCaja()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    },
                )
        },
        desaprobarRendicion() {
            RendicionService
                .desaprobar({
                    caj_id: this.caja.caj_id
                }).then(
                    response => {
                        Toast.success(response.message)
                        this.obtenerCaja()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    },
                )
        },
        editar() {
            this.$router.push(`/caja/edit/${this.caja.caj_id}`)
        },
        depositar() {
            CajaService
                .depositar({
                    caj_id: this.caja.caj_id
                }).then(
                    response => {
                        Toast.success(response.message)
                        this.obtenerCaja()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    },
                )
        },
        cancelar() {
            CajaService
                .cancelar({
                    caj_id: this.caja.caj_id
                }).then(
                    response => {
                        Toast.success(response.message)
                        this.obtenerCaja()
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    },
                )
        },
        obtenerRendiciones(rendicion) {
            RendicionService
                .obtenerRendiciones(rendicion).then(
                    response => {
                        this.rendicion = response.data
                        this.documentos = this.rendicion?.lista_rendicion_detalle
                    },
                    error => {
                        console.error(`error: `, error)
                    }
                )
        },
        agregarRendicion() {
            this.$router.push(`/rendicion/new/${this.caja.caj_id}/${this.caja.caj_codigo}`)
        },
    },
    mounted() {
        this.obtenerCaja()
    }
}
</script>
<style scoped>
.nj-cols form {
    margin-bottom: 12px;
}

.headers {
    display: grid;
    grid-template-columns: 40px 100px 120px repeat(2, 1fr) 200px 200px 100px 100px 100px;
    align-items: center;
    border: 1px solid #0077b6 !important;
    background-color: #0077b6 !important;
    color: #fff;
}

.headers>.item {
    padding: 6px;
}

.details {
    display: grid;
    grid-template-columns: 40px 100px 120px repeat(2, 1fr) 200px 200px 100px 100px 100px;
    align-items: center;
    border-bottom: 1px solid #ccc;
}

.details>.item {
    padding: 6px;
}

.calculos {
    display: grid;
    grid-template-columns: 40px 100px 120px repeat(2, 1fr) 200px 200px 100px 100px 100px;
    grid-template-areas:
        ". . . . . . . . label-total value-total"
        ". . . . . . . . label-saldo value-saldo";
    align-items: center;
    border-bottom: 1px solid #ccc;
}

.calculos>.item {
    padding: 6px;
}

.bold {
    font-weight: bold;
}

.pdf-adjunto {
    border: 1px solid #ea4335;
    background-color: #ea4335;
    border-radius: 2px;
    display: inline-flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    padding: 8px;
}

.pdf-adjunto * {
    color: #fff;
}

.pdf-adjunto i {
    font-size: 32px;
}

.pdf-adjunto:hover,
.pdf-adjunto:visited {
    color: unset;
}

@media (max-width: 768px) {
    .hide {
        display: none;
    }

    .totales {
        flex-direction: column;
    }
}
</style>